module.exports = __webpack_public_path__ + "img/seedpaper-swiss-red.c7b3d9aa.png";